import axios from '@axios'

export default {
    namespaced: true,
    state: {
        tipoEmpresa: [],
        estados: [],
        current_page: 1,
        last_page: 0,
        per_page: 0,
        total: 0,
        paises: [],
        provincias: [],
        ciudades: [],
        tipos: [],
        provee: [],
        grupos: [],
        vendedores: [],
        canales: [],
        bancos: [],
        categoriaCliente: [],
        cuentas: [],
        tipo: [],
        tipoCliente: [],
        zonas: [],
        subtipo: [],
        formasPago: [],
    },
    getters: {
        getSegmentacion(state) {
            return state.cartera
        }
    },
    mutations: {
        SET_SEGMENTACION(state, cartera) {
            state.cartera = cartera
        },
        SET_DOCUMENTOS(state, documentos) {
            state.documentos = documentos
        },
        SET_A06T1(state, SRI) {
            state.SRI = SRI
        },
        SET_PAGES(state, current_page) {
            state.current_page = current_page
        },
        SET_TOTAL_PAGES(state, last_page) {
            state.last_page = last_page
        },
        SET_PER_PAGE(state, per_page) {
            state.per_page = per_page
        },
        SET_TOTAL(state, total) {
            state.total = total
        },
        SET_ESTADO(state, documentoId) {
            const detalle = state.SRI.find(p => p.codigo === documentoId)
            detalle.principal = 0
        },
    },
    actions: {
        fetchCartera({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/segmentacionCartera')
                    .then((response) => {
                        commit('SET_SEGMENTACION', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchUser({ commit }, userId) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/sri/editarA06T1/${userId}`)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => { reject(error) })
            })
        },
        fetchDocumentos({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/sri/documentos')
                    .then((response) => {
                        commit('SET_DOCUMENTOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postA06t1({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/sri/agregarA06T1', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postEditA06t1({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.put('/api/auth/sri/editarA06T1', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        deleteA06T1({ commit }, documentoId) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/sri/eliminarA06T1', { documentoId: documentoId })
                    .then((response) => {
                        commit('SET_ESTADO', documentoId)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchA06T1({ commit }, data) {
            if (data) {
                commit('SET_PAGES', data['page'])
                var url = `/api/auth/sri?page=${data['page']}`
                if (data['division']) {
                    url += `&division=${data['division']}`
                }
                if (data['co_tipo']) {
                    url += `&co_tipo=${data['co_tipo']}`
                }
                if (data['NumAuto']) {
                    url += `&NumAuto=${data['NumAuto']}`
                }
                if (data['Fecha_emision']) {
                    url += `&Fecha_emision=${data['Fecha_emision']}`
                }
                if (data['Fecha_caduca']) {
                    url += `&Fecha_caduca=${data['Fecha_caduca']}`
                }
                if (data['num_desde']) {
                    url += `&num_desde=${data['num_desde']}`
                }
                if (data['num_hasta']) {
                    url += `&num_hasta=${data['num_hasta']}`
                }
                if (data['electronico']) {
                    url += `&electronico=${data['electronico']}`
                }
                if (data['principal']) {
                    url += `&principal=${data['principal']}`
                }
                return new Promise((resolve, reject) => {
                    axios.get(url)
                        .then((response) => {
                            commit('SET_A06T1', response.data.data)
                            commit('SET_TOTAL_PAGES', response.data.last_page)
                            commit('SET_PER_PAGE', response.data.per_page)
                            commit('SET_TOTAL', response.data.total)
                            resolve(response)
                        })
                        .catch((error) => {
                            reject(error);
                        })
                })
            }
        },
    },
}